import { HeartIcon as HeartIconOutline } from '@heroicons/react/24/outline';
import { HeartIcon } from '@heroicons/react/24/solid';
import { usePatchToggleFavoriteAccountRepresentativeMutation } from '@/slices/account-representative-api-slice.ts';
import type { AccountRepresentativeListModel } from '../../types/account-representative.type.ts';

const RepFavorite = ({ data }: { data: AccountRepresentativeListModel }) => {
  const [patchFavorite] = usePatchToggleFavoriteAccountRepresentativeMutation();

  return (
    <>
      {data?.isFavorite ? (
        <HeartIcon
          onClick={event => {
            event.stopPropagation();
            patchFavorite(data?.key);
          }}
          className='w-5 h-5 cursor-pointer'
          color='red'
        />
      ) : (
        <HeartIconOutline
          onClick={event => {
            event.stopPropagation();
            patchFavorite(data?.key);
          }}
          className='w-5 h-5 cursor-pointer'
        />
      )}
    </>
  );
};

export default RepFavorite;
